import React from "react";

const Access_Strings = () => {
  return (
    <div>
      <h1>Access_Strings Component</h1>
      <p>Content for Access_Strings goes here...</p>
    </div>
  );
};

export default Access_Strings;
